import { FC } from 'react'

import { SimpleModal } from '@sequencehq/core-components'

import { useCustomerContactsContext } from 'modules/CustomerContacts/communication/internal/CustomerContacts.domain.context'
import { useContactModalForm } from '../forms/ContactModalForm/useContactModalForm'
import { ContactModalForm } from '../forms/ContactModalForm/ContactModalForm'
import { CustomerContactPurpose } from 'CustomerContacts/types'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSubmit?: () => void
  onCancel?: () => void
  purposes?: CustomerContactPurpose[]
}

export const CreateContactModal: FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  onCancel,
  purposes
}) => {
  const ctx = useCustomerContactsContext()

  const { fieldsConfig, formErrors, buttonSubmit, resetForm } =
    useContactModalForm({
      contactId: 'new',
      customerId: ctx.queries.data.customerId,
      fieldsValues: {
        ...ctx.queries.formData,
        purposes: purposes ?? ctx.queries.formData.purposes
      },
      updateFields: ctx.mutators.internal.updateForm,
      createContact: ctx.mutators.external.out.createContact,
      updateContact: ctx.mutators.external.out.updateContact
    })

  return (
    <SimpleModal
      isOpen={isOpen}
      data-testid="contacts.createModal"
      title="Add contact"
      cancelButtonText="Cancel"
      submitButtonText="Add contact"
      submitDisabled={buttonSubmit.disabled}
      onClose={() => {
        resetForm()
        onCancel?.()
        onClose()
      }}
      onSubmit={async () => {
        const success = await buttonSubmit.onSubmit(onSubmit)

        if (success) {
          // Close directly so the dismissal path (resetForm + onCancel)
          // doesn't run on a successful submit.
          onClose()
        }

        return false
      }}
    >
      <ContactModalForm fieldsConfig={fieldsConfig} formErrors={formErrors} />
    </SimpleModal>
  )
}
